import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { baseApi, cicoApi, payApi, swapApi } from "apis";

// import { logger } from "redux-logger";
import { hideDevLogs, isProd } from "config";
import errorHandler from "./middlewares/errorHandler";
import { ErrorReducer, AuthReducer, UserReducer, FormReducer } from "./slices";

// const devMiddlewares = isProd ? [] : [logger];

const store = configureStore({
  reducer: {
    auth: AuthReducer,
    user: UserReducer,
    error: ErrorReducer,
    form: FormReducer,
    [swapApi.reducerPath]: swapApi.reducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [payApi.reducerPath]: payApi.reducer,
    [cicoApi.reducerPath]: cicoApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      // ...devMiddlewares,
      errorHandler,
      swapApi.middleware,
      payApi.middleware,
      cicoApi.middleware,
      baseApi.middleware
    ]),
  devTools: !isProd && !hideDevLogs,
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useDispatch: AppDispatch = store.dispatch;
export default store;
